module.exports = function(app) {

   app.controller("pages.spending.spendingAccountSettings", ["$scope", "session","services", "storage","coremetrics","sessionData","spendingAccountsService","spaUtil",
        function( $scope, session,services, storage,coremetrics,sessionData,spendingAccountsService,spaUtil){
            $scope.spendingAccountSettings = "spendingAccountSettings";
            var passData = {};

            var SASdata = storage.get("SASdata");

            passData.groupNumber = SASdata.groupCode;
            passData.memberId = SASdata.participantCode;
            passData.csr = false;
            passData.userRole = "MEMBER";

            var accountType = SASdata.accountType;
            var cancelledAcct = SASdata.cancelledAcct;
            var futureAcct = SASdata.futureAcct;
            $scope.isCSR =spaUtil.isCSR();
            $scope.currentHSAAccount=false;

            if (accountType == "HSA" && !cancelledAcct && !futureAcct) {
                $scope.currentHSAAccount=true;
            }



            $scope.goToAcclaris =function(buttonOption){
                if(buttonOption=='editDDBtn'){
                    //topic.publish("SPA-Coremetrics-SAS-Edit Direct Deposit");
                    passData.DLParams = "obj~EEACHEDIT-Page";
                }else if(buttonOption=='editBeneficiariesBtn'){
                    //topic.publish("SPA-Coremetrics-SAS-Edit Beneficiaries");
                    passData.DLParams = "obj~EEPRFLSMRYPAGE-Page";
                }else if(buttonOption=='editAutoPayBtn'){
                    //topic.publish("SPA-Coremetrics-SAS-Edit Auto-Pay Preferences");
                    passData.DLParams = "obj~MNGPYMNTOPTS-Page";
                }else if(buttonOption=='viewProfileBtn'){
                    //topic.publish("SPA-coremetrics-SAS-View Profile");
                    passData.DLParams = "obj~EEPRFLSMRYPAGE-Page";
                }
                spaUtil.newAcclaris(passData);
            }



        }])

};